<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            width="30%"
            :visible.sync="view.visible">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="80px" class="role-dialog-form">
            <el-form-item label="角色名称" prop="name">
                <el-input v-model="dataForm.name" placeholder="角色名称"></el-input>
            </el-form-item>
            <el-form-item label="角色编码" prop="code">
                <el-input
                        v-model="dataForm.code"
                        placeholder="角色编码">
                </el-input>
            </el-form-item>
            <el-form-item label="主体" prop="mainBodyName">
                <el-input
                        v-model="dataForm.mainBodyName"
                        :disabled="true"
                        clearable
                        placeholder="请选择"
                        style="width: 100%">

                </el-input>
            </el-form-item>
            <el-form-item label="租户" prop="tenantName">
                <el-input
                        v-model="dataForm.tenantName"
                        :disabled="true"
                        clearable
                        placeholder="请选择"
                        style="width: 100%">

                </el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
            </el-form-item>
        </el-form>
        <el-row>
            <el-col style="text-align: right;">
                <el-button size="small" @click="view.visible = false">取消
                </el-button>
                <el-button size="small" type="primary" @click="dataFormSubmit()">确定
                </el-button>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script>
    import {getRoleById, createRole, editRole} from '@/controller/sys'
    export default {
        data() {
            return {
                view: {
                    visible: false,
                    conheight: {
                        height: this.$store.state.common.documentClientDefaultHeight * 0.9 - 410 + 'px',
                        'overflow-y': 'auto'
                    }
                },
                viewData: {},
                dataForm: {
                    id: 0,
                    name: '',
                    code: '',
                    remark: '',
                    tenantId: '',
                    tenantName: '',
                    mainBodyName: ''
                },
                dataRule: {
                    name: [
                        {required: true, message: '角色名称不能为空', trigger: 'blur'}
                    ],
                    code: [
                        {required: true, message: '角色编码不能为空', trigger: 'blur'}
                    ],
                    mainBodyName: [
                        {required: true, message: '请先在页面顶部导航栏选择主体', trigger: 'blur'}
                    ],
                    tenantName: [
                        {required: true, message: '请先在页面顶部导航栏选择租户', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init(id) {
                this.dataForm.id = id || 0
                this.view.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    this.dataForm.tenantName = sessionStorage.getItem('tenantName')
                    this.dataForm.mainBodyName = sessionStorage.getItem('mainBodyName')
                    if (this.dataForm.id) {
                        getRoleById(
                            {},this.dataForm.id
                        ).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm.code = data.body.roleCode
                                this.dataForm.name = data.body.roleName
                                this.dataForm.remark = data.body.roleDesc
                                if(parseInt(data.body.tenantId) !== parseInt(sessionStorage.getItem('tenantId'))
                                    || parseInt(data.body.mainBodyId) !== parseInt(sessionStorage.getItem('mainBodyId'))){
                                    this.view.visible = false
                                    this.$message({
                                        message: '该角色不属于当前租户或主体，请在导航栏切换！',
                                        type: 'info'
                                    })
                                }
                            }
                        })
                    }
                })
            },
            // 表单提交
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        if(this.dataForm.id){
                            editRole(
                                {
                                    'id': this.dataForm.id || undefined,
                                    'roleName': this.dataForm.name,
                                    'roleCode': this.dataForm.code,
                                    'roleDesc': this.dataForm.remark
                                }
                            ).then(data => {
                                if (data && data.code === '00') {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success',
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false
                                            this.$emit('refreshDataList')
                                        }
                                    })
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })
                        }else{
                            createRole(
                                {
                                    'id': this.dataForm.id || undefined,
                                    'roleName': this.dataForm.name,
                                    'roleCode': this.dataForm.code,
                                    'roleDesc': this.dataForm.remark
                                }
                            ).then(data => {
                                if (data && data.code === '00') {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success',
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false
                                            this.$emit('refreshDataList')
                                        }
                                    })
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })
                        }
                    }
                })
            }
        }
    }
</script>
<style lang="scss">
    .el-dialog__body {
        .role-dialog-form {
            width: 95%;
        }
    }
</style>
